var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.story
    ? _c(
        "a",
        {
          staticClass: "story-card w-100 h-100",
          attrs: { href: _vm.route("nl.story", { slug: _vm.story.slug }) }
        },
        [
          _vm.story.acf.image
            ? _c("div", { staticClass: "zoom-wrapper" }, [
                _c("div", {
                  staticClass: "background-wrapper w-100 h-100",
                  style:
                    "background-image: url('" +
                    _vm.story.acf.image.sizes.large +
                    "')"
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "content d-flex w-100 h-100 flex-column justify-content-end p-24 p-lg-40"
            },
            [
              _c("h3", {
                staticClass: "mb-16 text-white",
                domProps: { innerHTML: _vm._s(_vm.story.title.rendered) }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "d-block" }, [
                _c("span", { staticClass: "text-white" }, [
                  _vm._v(_vm._s(_vm.story.acf.author))
                ]),
                _c("span", { staticClass: "text-white font-weight-light" }, [
                  _vm._v(" - " + _vm._s(_vm.story.acf.participants))
                ])
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }